import type { DateNightAnswers, DateNightStep } from "../types/dateNight";

type Draft = { currentStep: DateNightStep; answers: DateNightAnswers; lastUpdated: string };

const key = (token: string) => `date-night-draft-${token}`;

export function loadDraft(token: string): Draft | null {
  try {
    const raw = localStorage.getItem(key(token));
    return raw ? (JSON.parse(raw) as Draft) : null;
  } catch {
    return null;
  }
}

export function saveDraft(token: string, currentStep: DateNightStep, answers: DateNightAnswers) {
  localStorage.setItem(key(token), JSON.stringify({ currentStep, answers, lastUpdated: new Date().toISOString() } satisfies Draft));
}

export function clearDraft(token: string) {
  localStorage.removeItem(key(token));
}
